import './App.css';
import { MainMap } from './components/Map';

function App() {
  return (
    <>
      <MainMap />
    </>
  );
}

export default App;
